<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>{{ document.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn dark color="indigo" @click="$router.go(-1)">
        <v-icon left>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-toolbar>

    <v-container>
      <img v-if="document.file_type != 'pdf'" :src="link()" />
      <a v-if="document.file_type == 'pdf'" target="_blank" :href="link()">{{
        document.name
      }}</a>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    document: {
      type: Object,
      required: true
    }
  },

  methods: {
    link() {
      return process.env.VUE_APP_CORE_API + '/../storage/' + this.document.file;
    }
  }
};
</script>
